import { MediaType } from '@confluence/graphql/entry-points/MediaType.ts';
import { useExperimentalMutation } from '@confluence/legacy-schema-bridge/entry-points/useExperimentalMutation.ts';

import type {
	EditorStopHeartbeatMutation as EditorStopHeartbeatMutationData,
	EditorStopHeartbeatMutationVariables,
} from './__types__/EditorStopHeartbeatMutation.ts';
// oxlint-disable-next-line graphql-relay-compat/no-interop-imports -- see https://go.atlassian.com/cfe-no-interop-imports
import type { ApolloErrorInterop } from '@confluence/apollo-relay-interop-utils/entry-points/ApolloErrorInterop.ts';

export const useExperimentalEditorStopHeartbeatMutation = ({
	variables,
}: {
	variables: EditorStopHeartbeatMutationVariables;
}): [
	(
		options?:
			| {
					variables?: EditorStopHeartbeatMutationVariables | undefined;
					update?:
						| ((
								cache: null,
								result: {
									data?: EditorStopHeartbeatMutationData | null | undefined;
								},
						  ) => void)
						| undefined;
					optimisticResponse?:
						| EditorStopHeartbeatMutationData
						| ((vars: EditorStopHeartbeatMutationVariables) => EditorStopHeartbeatMutationData)
						| undefined;
			  }
			| undefined,
	) => Promise<{
		data: EditorStopHeartbeatMutationData | undefined;
	}>,
	{
		data: EditorStopHeartbeatMutationData | undefined;
		loading: boolean;
		error: ApolloErrorInterop | undefined;
		called: boolean;
	},
] => {
	return useExperimentalMutation<
		EditorStopHeartbeatMutationData,
		EditorStopHeartbeatMutationVariables,
		boolean
	>({
		url: '/wiki/api/v2/editor/heartbeat/stop',
		method: 'POST',
		variables,
		headers: {
			Accept: MediaType.JSON,
			'Content-Type': MediaType.JSON,
		},
		body: ({ contentId, contentType, heartbeatUserType }) =>
			JSON.stringify({
				dataType: 'json',
				contentId,
				draftType: contentType ?? '',
				heartbeatUserType,
			}),
		parseResponseOnError: () => {
			return false;
		},
		parseResult: (response) => {
			return {
				experimentalEditorStopHeartbeat: Boolean(response),
			};
		},
	});
};
